import styled from 'styled-components';
import {HOME_PAGE} from '../../../../themes/css-global-classes';
import {SwiperWrapperDefaultBox} from './swiper-wrapper.default.box';

export const SwiperWrapperMrGreenBox = styled(SwiperWrapperDefaultBox)`
    @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
        .${HOME_PAGE} & {
            width: 100%;
        }
    }

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        padding-left: 6px;
    }
`;
